import styles from './Input.module.css';

const Input = ({ label, placeholder, value, onChange, type = 'text', prefix, id }) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return (
    <div className={styles.wrapper}>
      {label && <label htmlFor={inputId} className={styles.label}>{label}</label>}
      <div className={styles.inputRow}>
        {prefix && <span className={styles.prefix}>{prefix}</span>}
        <input
          id={inputId}
          type={type}
          className={`${styles.input} ${prefix ? styles.withPrefix : ''}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          min={type === 'number' ? 0 : undefined}
        />
      </div>
    </div>
  );
};

export default Input;
